import { FulfillmentGroupReassignmentReasonSchema } from "@redotech/redo-fulfillment-group-common/reassignment-reason";
import * as z from "zod";
import { ReassignmentLocationSchema } from "./get-reassignment-locations";

export const getMerchantReassignmentLocations = {
  name: "getMerchantReassignmentLocations" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({ locations: z.array(ReassignmentLocationSchema) }),
};

export const assignFulfillmentGroupToMerchant = {
  name: "assignFulfillmentGroupToMerchant" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    externalLocationId: z.string().nullish(),
    reason: FulfillmentGroupReassignmentReasonSchema,
    note: z.string().max(500).nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
